import { updateTour } from 'src/actions/actionTypes'

const initialState = {
  riskScoreInputTour: false,
  riskScoreTour: false,
  riskScoreTourPopup: false,
  policyTileCardTour: false,
  insuranceDetailsTour: false,
}

const tourReducer = (state = initialState, action) => {
  switch (action.type) {
    case updateTour.START_RISK_SCORE_TOUR:
      return {
        ...state,
        riskScoreTour: action.payload,
      }
    case updateTour.START_RISK_SCORE_TOUR_POPUP:
      return {
        ...state,
        riskScoreTourPopup: action.payload,
      }
    case updateTour.START_POLICY_TILE_CARD_TOUR:
      return {
        ...state,
        policyTileCardTour: action.payload,
      }
    case updateTour.START_INSURANCE_DETAILS_TOUR:
      return {
        ...state,
        insuranceDetailsTour: action.payload,
      }
    case updateTour.START_RISK_SCORE_INPUT_TOUR:
      return {
        ...state,
        riskScoreInputTour: action.payload,
      }
    default:
      return state
  }
}

export default tourReducer
